<template>
  <div class="input dropdown general">
    <div class="fields">
      <label v-if="label" for="ddid">{{ label }}</label>
      <select id="ddid" :aria-label="ariaLabel" v-model="selected" @change="handleChange">
        <option v-for="o in options" :value="o.value">{{ o.label }}</option>
      </select>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import type { Option } from '../../types/GenericTypes';

const selected = defineModel<string>();

const props = defineProps({
  label: {
    type: String,
    required: false,
  },
  options: {
    type: Array<Option>,
    required: true,
  },
});
const emit = defineEmits<{
  (event: 'change', value: string): void;
}>();

const selectedOption = () => {
  return !selected.value ? null : props.options.find((o) => o.value === selected.value);
};

const handleChange = (event: Event) => {
  const v = (event.target as HTMLSelectElement).value;
  selected.value = v;
  emit('change', v);
};

const ariaLabel = computed(() => {
  let v = `${props.label}.`;
  const o = selectedOption();
  if (o) {
    v += ` Redan vald: ${o.label}.`;
  }
  return v;
});
</script>
